/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DesignInstallation } from "./DesignInstallation";
import {
  DesignInstallationFromJSON,
  DesignInstallationFromJSONTyped,
  DesignInstallationToJSON,
  DesignInstallationToJSONTyped,
} from "./DesignInstallation";

/**
 *
 * @export
 * @interface ApiGufInstallationsList200Response
 */
export interface ApiGufInstallationsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGufInstallationsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGufInstallationsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGufInstallationsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<DesignInstallation>}
   * @memberof ApiGufInstallationsList200Response
   */
  results: Array<DesignInstallation>;
}

/**
 * Check if a given object implements the ApiGufInstallationsList200Response interface.
 */
export function instanceOfApiGufInstallationsList200Response(
  value: object
): value is ApiGufInstallationsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGufInstallationsList200ResponseFromJSON(
  json: any
): ApiGufInstallationsList200Response {
  return ApiGufInstallationsList200ResponseFromJSONTyped(json, false);
}

export function ApiGufInstallationsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGufInstallationsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(DesignInstallationFromJSON),
  };
}

export function ApiGufInstallationsList200ResponseToJSON(
  json: any
): ApiGufInstallationsList200Response {
  return ApiGufInstallationsList200ResponseToJSONTyped(json, false);
}

export function ApiGufInstallationsList200ResponseToJSONTyped(
  value?: ApiGufInstallationsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(DesignInstallationToJSON),
  };
}
